import { useMutation, useQueryClient } from "@tanstack/react-query";
import { conciliarCfdiContrapagoApi } from "@/features/conciliar-cfdi-contrapago/services/conciliar-cfdi-contrapago.api";
import { qk } from "@/lib/query-keys";
import { toastError, toastExito } from "@/lib/toast";
import type { CargarCFDIResultado } from "@/lib/types";
import { extractApiMessage } from "@/shared/api/extract-message";

export function useConciliarCfdiContrapago(
  solicitudId: string,
  options?: {
    onReglasAutorizadas?: (r: CargarCFDIResultado) => void;
    onReglasRechazadas?: (r: CargarCFDIResultado) => void;
  }
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (xml: File) => conciliarCfdiContrapagoApi.conciliar(solicitudId, xml),
    onSuccess: (r) => {
      qc.setQueryData(qk.solicitud(solicitudId), r.solicitud);
      if (r.reglasAutorizadas) {
        toastExito({ title: "CFDI conciliado", message: "El CFDI real coincide con lo capturado · la solicitud quedó completa." });
        options?.onReglasAutorizadas?.(r);
      } else {
        toastError({ title: "CFDI rechazado", message: `${r.erroresReglas.length} regla(s) rechazaron el CFDI` });
        options?.onReglasRechazadas?.(r);
      }
    },
    onError: (e) => toastError({ title: "Error", message: extractApiMessage(e, "Error conciliando el CFDI") }),
  });
}
